"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheTrainingRoom() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="146113" id="geist-der-stille" className="dark bg-background text-foreground relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/sun_drenched_forest_clearing.png)]" aria-hidden="true" />
      
      <div className="absolute inset-0 z-10 bg-black/15" aria-hidden="true" />

      <div ref={ref} className={`relative z-20 text-center px-4 flex flex-col items-center justify-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        
        <h1 className="text-4xl md:text-6xl lg:text-[7rem] font-sans font-light tracking-[0.15em] uppercase text-white leading-none mb-6">
          Tai Chi Schule <span className="!italic !text-[hsl(210,17%,98%)]">SOONWALD</span>
        </h1>
        
        <p className="text-xl md:text-2xl font-light tracking-[0.1em] text-white/95 uppercase mb-8">Claudia Christ</p>
        
        <div className="flex flex-col items-center">
          <div className="w-12 h-[1px] bg-white/40 mb-8" />
          <p className="text-2xl md:text-3xl font-light italic tracking-[0.05em] text-white/90">
            Geist der Stille. Kraft der Bewegung.
          </p>
        </div>
        
        <div className={`mt-16 w-px h-24 bg-white/30 origin-top transition-transform duration-1000 delay-500 ease-out ${isVisible ? "scale-y-100" : "scale-y-0"}`} aria-hidden="true" />
      </div>
    </section>;
}